import {
  Text,
  Button,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogCloseButton,
} from "@chakra-ui/react";

import React from "react";
// import Strings from '../../config/Strings';
import PaymentStrings from "./PaymentStrings";

function InfoPanel() {

  return (
    <>
      <Text>
        {PaymentStrings.add_payment_dialog.description.line1}
        <br />
        <br />
      </Text>
      <Text>
        {PaymentStrings.add_payment_dialog.description.line2}
        <br />
        <br />
      </Text>
      <Text>{PaymentStrings.add_payment_dialog.description.line3}</Text>
    </>
  )
}

export default function AddPaymentAlert({ disclosure, onCompleted }) {
  return (
    <AlertDialog
      // size={"sm"}
      isOpen={disclosure.isOpen}
      onClose={disclosure.onClose}
      closeOnOverlayClick={false}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {PaymentStrings.add_payment_dialog.title}
            <AlertDialogCloseButton />
          </AlertDialogHeader>

          <AlertDialogBody>
            
            <InfoPanel />

          </AlertDialogBody>

          <AlertDialogFooter>
            <Button
              mr={4}
              colorScheme={"green"}
              onClick={() => {
                onCompleted(true);
                disclosure.onClose();
              }}
            >
              {PaymentStrings.add_payment_dialog.add_now}
            </Button>

            <Button
              mr={4}
              colorScheme={"gray"}
              onClick={() => {
                onCompleted(false);
                disclosure.onClose();
              }}
            >
              {" "}
              {PaymentStrings.add_payment_dialog.add_later}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
